import React from 'react';
import { Modal } from './Modal';
import './HelpModal.css';

export const PotentialHelpModal: React.FC<{ isOpen: boolean; onClose: () => void; }> = ({ isOpen, onClose }) => (
    <Modal isOpen={isOpen} onClose={onClose} className="help-modal">
        <h2>Player Progression Explained</h2>
        <p>A player's development is a key part of building a successful team. It's driven by age and their hidden 'Potential' rating.</p>

        <div className="help-section">
            <h3>What is Potential?</h3>
            <p>Potential is a hidden rating from 1-99 that represents the maximum possible 'Skill' a player can ever reach. You can get a rough idea of a player's potential from their <button className="potential-badge-button"><span className="potential-badge potential-elite">BADGE</span></button>.</p>
        </div>
        
        <div className="help-section">
            <h3>End-of-Season Progression/Regression</h3>
            <p>At the end of each season, players' skills will change based on their age:</p>
            <ul>
                <li><strong>Under 23:</strong> High chance to gain 1-3 skill points per season, as long as their skill is below their potential. This is their prime development phase.</li>
                <li><strong>Ages 23-28:</strong> Smaller chance to gain 1-2 skill points. They are entering their peak years.</li>
                <li><strong>Ages 29+:</strong> High chance to lose 1-3 skill points per season as they decline. Potential no longer matters.</li>
            </ul>
        </div>
        
        <div className="help-section">
            <h3>Weekly Training</h3>
            <p>In addition to seasonal changes, players have a small chance to gain +1 skill each week through training. The chance is higher for younger players and those who played in the week's match.</p>
        </div>
        
        <div className="help-section">
            <h3>Youth Academy</h3>
            <p>Your Youth Academy generates new players every 4 weeks. Upgrading your academy increases the quality and potential of these new talents. There's always a small chance of unearthing a 'wonderkid' with <span className="potential-badge potential-elite">ELITE</span> potential!</p>
        </div>

        <div className="modal-actions">
            <button className="button" onClick={onClose}>Close</button>
        </div>
    </Modal>
);
